import { render, staticRenderFns } from "./site-identity-section.vue?vue&type=template&id=3c0e2001&scoped=true"
import script from "./site-identity-section.vue?vue&type=script&lang=js"
export * from "./site-identity-section.vue?vue&type=script&lang=js"
import style0 from "./site-identity-section.vue?vue&type=style&index=0&id=3c0e2001&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0e2001",
  null
  
)

export default component.exports